import { render, staticRenderFns } from "./AddNotif.vue?vue&type=template&id=2b75763c&"
import script from "./AddNotif.vue?vue&type=script&lang=js&"
export * from "./AddNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports